module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('a', {
    attrs: {
      "id": "not"
    }
  }), _vm._v("NOTE ON TRANSLATION")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("All translations are mine, unless otherwise noted. Cities in the multi-ethnic Austrian empire and its successors almost always had a German name as well as a second version, as in Lemberg/Lwów. Depending on the time and the circumstances, I have tried to use the German name or the Slavic one, following Hugo Huppert’s usage, which usually favors the German name he grew up with, as in Teschen and Bielitz.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-736a82e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/not.vue
// module id = 81
// module chunks = 0